import { render, staticRenderFns } from "./user-handle-modal.vue?vue&type=template&id=d955040e&"
import script from "./user-handle-modal.vue?vue&type=script&lang=js&"
export * from "./user-handle-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports